// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ExclamationOutlinedSvg from "@ant-design/icons-svg/es/asn/ExclamationOutlined";
import AntdIcon from '../components/AntdIcon';

var ExclamationOutlined = function ExclamationOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: ExclamationOutlinedSvg
  }));
};

ExclamationOutlined.displayName = 'ExclamationOutlined';
export default React.forwardRef(ExclamationOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/ExclamationOutlined.js
// module id = 1037
// module chunks = 0